import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";
import Form from "react-bootstrap/Form";
import {
  EditIcon,
  CopyIcon,
  TrashIcon,
  UploadIcon,
  SignatureIcon,
} from "../../components/SVGIcon";

const capitalizeFirstLetter = (str) => {
  if (str.length === 0) {
    return ""; // Handle empty strings
  }
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const SignatureSchema = {
  name: "Signature",
  tag: "Signature",
  fields: [
    {
      type: "expertSignature",
      label: "Participant 1",
      placeholder: "Enter Participant 1 Name",
      selectedDropdownValue: "expert",
      value: "",
      isDigital: "digital"
    },
    {
      type: "recipientSignature",
      label: "Participant 2",
      placeholder: "Enter Participant 2 Name",
      selectedDropdownValue: "recipient",
      value: "",
      isDigital: "digital"
    },
  ],
};

const SignatureSection = ({
  singleDefaultElementTypes,
  // templateJson,
  // handleSectionNameChange,
  // isCreateReportRoute,
  // setTemplateJson,
  // dropdownOptions,
  // section,
  // index,
  section,
  index,
  markSectionEditing,
  conversationData,
  dropdownOptions,
  isCreateReportRoute,
  updateSection
}) => {
  const [showModal, setShowModal] = useState(false);
  const [fields, setFields] = useState([]);
  const [isEditModeOn, setIsEditModeOn] = useState(false);
  // LOCAL EDIT STATE
  const [localFields, setLocalFields] = useState([]);
  const [localSectionName, setLocalSectionName] = useState("");
  const [hasInvalidFields, setHasInvalidFields] = useState(false);

  useEffect(() => {
    setFields(section?.fields ?? []);
    setLocalFields(section?.fields ?? []);
    setLocalSectionName(section?.name || "");
  }, [section]);

    useEffect(() => {
    const invalid = localFields.some(
      (f) =>
        (f.isDigital === 'digital' || f.type === "text") &&
        (!f.label?.trim() || !f.selectedDropdownValue?.trim())
    );
    setHasInvalidFields(invalid);
  }, [localFields]);

   const handleEdit = () => {
    setLocalFields(fields);
    markSectionEditing(section.id, true);
    setLocalSectionName(section?.name || "");
    setIsEditModeOn(true);
  };

  const handleDeleteSection = () => {
    updateSection(section.id, null); // parent removes it
    setShowModal(false);
    markSectionEditing(section.id, null);
  };

  const handleCancel = () => {
    setLocalFields(fields);
    setLocalSectionName(section?.name || "");
    setIsEditModeOn(false);
    markSectionEditing(section.id, false);
  };


  const handleSaveUpdate = () => {
    if (hasInvalidFields) return;

    updateSection(section.id, prevSection => ({
      ...prevSection,
      name: localSectionName,
      fields: [...localFields],
    }));

    setIsEditModeOn(false);
    markSectionEditing(section.id, false);
  };

  const handleLocalFieldChange = (row, key, value) => {
    setLocalFields((prev) =>
      prev.map((f, i) =>
        i === row ? { ...f, [key]: value } : f
      )
    );
  };

  const fieldsToRender = isEditModeOn ? localFields : fields;

  console.log("signature", fieldsToRender)
  return (
    <>
      <div className="d-flex align-items-center justify-content-between gap-3 p-3 border-bottom">
        {/* <h2 className="fs-20 fw-semibold mb-0">Signature</h2> */}
        {isEditModeOn ? (
          <Form.Control
            type="text"
            value={localSectionName}
            onChange={(e) => setLocalSectionName(e.target.value)}
            className="fs-20 fw-semibold mb-0 border-0 bg-transparent"
            style={{ maxWidth: "400px" }}
          />
        ) : (
          <Form.Control
            type="text"
            readOnly
            value={section?.name || ""}
            // onChange={(e) => setLocalSectionName(e.target.value)}
            // onChange={(e) => handleSectionNameChange(section.id, e.target.value)}
            className="fs-20 fw-semibold mb-0 border-0 bg-transparent"
            style={{ maxWidth: "400px" }}
          />
        )}
        <div className="d-flex align-items-center gap-1">
          {!isEditModeOn && (
            <Button
              variant="icon"
              className="btn-md text-blue-600"
              onClick={() => handleEdit(true)}
            >
              <EditIcon />
            </Button>
          )}
          {!isCreateReportRoute && <Button
            variant="icon"
            className="btn-md text-red-600"
            onClick={() => {
              setShowModal(true);
            }}
          >
            <TrashIcon />
          </Button>}
        </div>
      </div>
      <div className="p-3">
        <Row className="gx-3 gy-3 gy-md-0 mt-10">
          {fieldsToRender?.map((element, row) => {
            // CASE 1: Digital Signature (like isDigital:true)
            if (element.isDigital === "digital") {
              return (
                <Col md="6" key={row}>
                  <div className={`hover-input-group mb-4 ${!isEditModeOn ? "readonly" : ""}`}>
                    <div className="d-flex align-items-center flex-column gap-1">

                      {/* SIGNATURE LABEL */}
                      <input
                        type="text"
                        readOnly={isCreateReportRoute || !isEditModeOn}
                        className={`form-control-label ${isEditModeOn && !element.label?.trim() ? "border border-danger" : ""
                          }`}
                        placeholder={element.label}
                        value={element.label}
                        onChange={(e) => isEditModeOn && handleLocalFieldChange(row, "label", e.target.value)}
                      />

                    {/* DATA SOURCE DROPDOWN */}
                      {!isCreateReportRoute && (
                        <select
                          disabled={!isEditModeOn}
                          className={`form-control form-select ${isEditModeOn && !element.selectedDropdownValue?.trim() ? "border border-danger" : ""
                            }`}
                          value={element.selectedDropdownValue ?? ""}
                          onChange={(e) =>
                            isEditModeOn && handleLocalFieldChange(row, "selectedDropdownValue", e.target.value)
                          }
                        >
                          <option value="">Select data source</option>
                          {dropdownOptions.map((opt) => (
                            <option key={opt.key} value={opt.key}>
                              {opt.label}
                            </option>
                          ))}
                        </select>
                      )}
                      {isCreateReportRoute && (
                        <input
                          type="text"
                          readOnly
                          id={`section-title` + `${row}`}
                          className="form-control-label"
                          placeholder={element.label}
                          aria-label={element.label}
                          value={element.value ?? ""}
                          // onChange={(e) =>
                          //   isEditModeOn && handleLocalFieldChange(row, "value", e.target.value)
                          // }
                        />
                      )}

                  </div>
                  </div>
                  <Form.Label> Signature </Form.Label>
                  <div className="border border-gray-200 rounded-3 ratio ratio-21x9 d-block">
                    <div className="d-flex align-items-center flex-column justify-content-center gap-2">
                      {!isCreateReportRoute && <SignatureIcon className="text-gray-400" size={48} />}
                      {isCreateReportRoute && (
                        <p className="signature-font fs-24 text-gray-400">
                          {element.value}
                        </p>
                      )}
                    </div>
                  </div>
                </Col>
              );
            }
            if (element.isDigital === "field") {
              return (
                <Col md="6" key={row}>
                  <div className={`hover-input-group mb-4 ${!isEditModeOn ? "readonly" : ""}`}>
                    <div className="d-flex align-items-center flex-column gap-1">

                      <input
                        type="text"
                        readOnly={!isEditModeOn}
                        className={`form-control-label ${isEditModeOn && !element.label?.trim() ? "border border-danger" : ""
                          }`}
                        placeholder={element.label}
                        value={element.label}
                        onChange={(e) => isEditModeOn && handleLocalFieldChange(row, "label", e.target.value)}
                      />
                      <input
                        type="text"
                        className="form-control"
                        readOnly={!isEditModeOn}
                        placeholder={element.placeholder ? element.placeholder : "Enter Placeholder Text"}
                        value={element.value ?? element.placeholder ?? ""}
                        onChange={(e) =>
                          isEditModeOn && handleLocalFieldChange(row, "value", e.target.value)
                        }
                      />
                    </div>
                  </div>

                  {/* SIGNATURE BOX */}
                  <Form.Label> Signature</Form.Label>
                  <div className="border border-gray-200 rounded-3 ratio ratio-21x9 d-block">
                    <div className="d-flex align-items-center flex-column justify-content-center gap-2">
                      {!isCreateReportRoute && <SignatureIcon className="text-gray-400" size={48} />}
                      {isCreateReportRoute && (
                        <p className="signature-font fs-24 text-gray-400">
                          {element.value}
                        </p>
                      )}
                    </div>
                  </div>
                </Col>
              );
            }

            return null;
          })}

        </Row>
      </div>
      {isEditModeOn && (
        <div className="p-3 border-top">
          <Row className="gy-2 gy-sm-0">
            <Col md="8" className="d-flex align-items-center gap-2">
              {hasInvalidFields && (
                <p className="text-danger small mb-2">
                  Please fill in all label, placeholder, or data source fields before saving.
                </p>)}
              <Button
                variant="primary"
                className="btn-md"
                onClick={handleSaveUpdate}
                disabled={hasInvalidFields}
              >
                Save & Update
              </Button>

              <Button variant="outline-secondary" className="btn-md" onClick={handleCancel}>
                Cancel
              </Button>
            </Col>
            <Col md="4" className="text-sm-end">
              <Button
                variant="danger-light"
                className="btn-md"
                onClick={() => {
                  setShowModal(true);
                }}
              >
                Delete Section
              </Button>
            </Col>
          </Row>
        </div>
      )}

      <Modal
        className="info-modal"
        show={!!showModal}
        onHide={() => setShowModal(false)}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          <div className="text-center">
            <Image src="/images/delete-badge-red.svg" alt="Delete Badge" />
            <h2 className="fs-2 fw-semibold text-gray-700 mt-5 mb-2">
              Are you sure you want to delete this section?
            </h2>

            <div className="d-flex align-items-center gap-3">
              <Button
                variant="primary"
                className="btn w-100 mt-5"
                onClick={handleDeleteSection}
              >
                Yes, Delete It!
              </Button>
              <Button
                variant="gray"
                className="btn w-100 mt-5"
                onClick={() => setShowModal(false)}
              >
                No, Not Yet
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SignatureSection;
